import { render, staticRenderFns } from "./TeacherHistoryBottomPanel.vue?vue&type=template&id=3ebf1513&scoped=true&lang=pug&"
import script from "./TeacherHistoryBottomPanel.vue?vue&type=script&lang=ts&"
export * from "./TeacherHistoryBottomPanel.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherHistoryBottomPanel.vue?vue&type=style&index=0&id=3ebf1513&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebf1513",
  null
  
)

export default component.exports